export default __webpack_public_path__ + "static/media/play-icon.39ccb252.svg";